import * as React from 'react';
export const IcDatabase = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.97 17.82c-1.65 0-3.16-.2-4.43-.55-1.17-.31-2.11-.76-2.76-1.28v1.28c0 1.48 3.3 2.72 7.21 2.72s7.21-1.24 7.21-2.72v-1.28c-.64.52-1.61.96-2.8 1.28-1.25.35-2.78.55-4.43.55zM11.99 13.94c-1.65 0-3.18-.19-4.43-.52-1.17-.3-2.12-.71-2.76-1.2v1.2c0 1.4 3.3 2.57 7.21 2.57s7.21-1.17 7.21-2.57v-1.2c-.66.49-1.63.91-2.8 1.2-1.27.33-2.78.52-4.43.52zM16.42 9.27c-1.27.35-2.78.55-4.43.55s-3.18-.2-4.43-.55c-1.17-.31-2.12-.76-2.76-1.28v1.28c0 1.48 3.3 2.72 7.21 2.72s7.21-1.24 7.21-2.72V7.99c-.66.52-1.63.96-2.8 1.28z'
      fill='currentColor'
    />
    <path
      d='M11.99 8c3.982 0 7.21-1.343 7.21-3s-3.228-3-7.21-3C8.008 2 4.78 3.343 4.78 5s3.228 3 7.21 3z'
      fill='currentColor'
    />
  </svg>
);
